export default {
  meta: {
    title: '标准模型推荐详情',
    url: '/recommend/modal', // 埋点用，记录所属模块
    parentPath: ['/recommend/report'],
    breadcrumbs: {
      path: ['/recommend/report'],
      name: ['推荐报告查询'],
    },
  },
};
